__turbopack_context__.v({
  "menu": "SelectApp-module-scss-module__T3QezG__menu",
  "spacer": "SelectApp-module-scss-module__T3QezG__spacer",
});
